export default function () {
	window.addEventListener('pageshow', (event) => {
		let main = document.getElementsByTagName('main');
		if (main[0]) {
			if (main[0].classList.contains('page-offers') && event.persisted) {
				//This page was restored from the bfcache and this page is offers list => RELOAD
				window.location.reload();
			}
		}
	});
}
